const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD'
const DEACTIVATE_USER = 'DEACTIVATE_USER'
const POST_NEW_USER = 'POST_NEW_USER'
const GET_ORGANIZATION_USERS = 'GET_ORGANIZATION_USERS'
const PATCH_USER = 'PATCH_USER'
const PATCH_USER_PROFILE = 'PATCH_USER_PROFILE'

export default {
  RESET_USER_PASSWORD,
  DEACTIVATE_USER,
  POST_NEW_USER,
  GET_ORGANIZATION_USERS,
  PATCH_USER,
  PATCH_USER_PROFILE,
}
